// Сознательное исключение из правила «навигация только через роутер»:
// логаут — граница сессии, полная перезагрузка гарантированно сбрасывает
// стор, сокеты и императивный DOM (welcome), а appEntry на бутстрапе
// сам покажет welcome анониму на корне.
export const reloadToOrigin = (): void => {
  window.location.href = window.location.origin
}
